const { mergeMap } = require("rxjs/operators");
const { ofType } = require("redux-observable");

const { payment: paymentApi } = require("@doctoroncallcom/api/marketplace");
const { GET_PROVIDER_LIST, OZOPAY_PAYMENT, OZOPAY } = require("./constants");

const {
  getPaymentProviderListSuccess,
  getPaymentProviderListError,

  ozopayPaymentSuccess,
  ozopayPaymentError,

  ozopaySuccess,
  ozopayError,
} = require("./actions");
const { transactionDelivery } = require("../marketTransaction/actions");

const getPaymentProviderList = (action$, state$, { marketplace }) =>
  action$.pipe(
    ofType(GET_PROVIDER_LIST),
    mergeMap(() =>
      paymentApi
        .getPaymentProviderList(marketplace)
        .then((response) => getPaymentProviderListSuccess(response.data))
        .catch((error) => getPaymentProviderListError(error))
    )
  );

const ozopayPayment = (action$, state$, { marketplace }) =>
  action$.pipe(
    ofType(OZOPAY_PAYMENT),
    mergeMap((action) =>
      paymentApi
        .ozopayPayment(
          marketplace,
          action.payload.transactionId,
          action.payload.data
        )
        .then((response) => ozopayPaymentSuccess(response.data))
        .catch((error) => ozopayPaymentError(error))
    )
  );
const ozopay = (action$, state$, { marketplace }) =>
  action$.pipe(
    ofType(OZOPAY),
    mergeMap((action) =>
      paymentApi
        .ozopay(marketplace, action.payload.uuid)
        .then((response) => ozopaySuccess(response.data))
        .catch((error) => ozopayError(error))
    )
  );

module.exports = {
  getPaymentProviderList,
  ozopayPayment,
  ozopay,
};
